<template>
  <VDropdown
    placement="bottom-end"
    @apply-show="isFocusLoopActive = true"
    @apply-hide="isFocusLoopActive = false"
    class="tw-inline-flex"
    :disabled="isTooSmallScreenToDisplayDropdown"
  >
    <NavbarIconItem
      :has-red-indicator="!!notificationsStore.unseenCount"
      :indicator-value="notificationsStore.unseenCount"
      screen-reader-text="View notifications"
      @click="handleBellButtonClick"
    >
      <BellIcon
        class="tw-h-6 tw-w-6 tw-stroke-[1.5px] lg:tw-h-4 lg:tw-w-4 lg:tw-stroke-1"
      />
    </NavbarIconItem>
    <template #popper>
      <div class="tw-w-96 tw-overflow-hidden tw-rounded-lg tw-shadow-md">
        <FocusLoop
          :is-active="isFocusLoopActive"
          :auto-focus="false"
          is-arrows-navigation-active
        >
          <div>
            <div
              v-if="notificationsStore.notifications.length"
              class="tw-max-h-72 tw-divide-y tw-divide-neutral-200 tw-overflow-y-auto tw-p-2"
            >
              <div
                v-for="notification in notificationsPreview"
                :key="notification.id"
              >
                <Notification :notification="notification" is-in-dropdown />
              </div>
            </div>
            <div
              v-else
              class="tw-p-4 tw-text-center tw-text-xs tw-text-neutral-400"
            >
              You have no notifications.
            </div>
            <div
              class="tw-grid tw-place-items-center tw-items-center tw-border-t tw-border-t-neutral-200 tw-bg-white tw-text-sm tw-font-medium"
              :class="{
                'tw-grid-cols-2': notificationsStore.unreadCount !== 0,
              }"
            >
              <InertiaLink
                href="/notifications"
                class="tw-w-full tw-p-2 tw-text-center tw-text-primary-500 tw-transition-colors hover:tw-bg-primary-50"
              >
                View all
              </InertiaLink>
              <button
                v-if="notificationsStore.unreadCount !== 0"
                class="tw-w-full tw-p-2 tw-text-center tw-text-neutral-500 hover:tw-bg-neutral-50"
                @click="handleMarkAllNotificationsAsRead"
              >
                Mark all as read
              </button>
            </div>
          </div>
        </FocusLoop>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import BellIcon from '@/assets/images/icons/bell.svg'
import FocusLoop from '@/shared/components/FocusLoop.vue'
import NavbarIconItem from '@/shared/components/navbar/NavbarIconItem.vue'
import Notification from '@/modules/growthmentor/notifications/components/Notification.vue'
import { computed, ref } from 'vue'
import { useNotificationsStore } from '@/shared/stores/notifications.js'
import { router } from '@inertiajs/vue3'
import { useScreenWidth } from '@/shared/composables/useScreenWidth.js'
import { notify } from '@kyvg/vue3-notification'

const { screenWidth, tailwindScreens } = useScreenWidth()
const notificationsStore = useNotificationsStore()

const isFocusLoopActive = ref(false)
const notificationsPreview = computed(() =>
  notificationsStore.notifications.slice(0, 10),
)
const isTooSmallScreenToDisplayDropdown = computed(() => {
  return screenWidth < tailwindScreens.value.xs
})

const handleBellButtonClick = () => {
  // We don't want to show dropdown if screen is too small, that's why here is redirect and popover is disabled
  if (isTooSmallScreenToDisplayDropdown.value) {
    router.visit('/notifications')
  }
  if (notificationsStore.unseenCount === 0) return
  notificationsStore.markAllNotificationsAsSeen()
}

const handleMarkAllNotificationsAsRead = () => {
  notificationsStore.markAllNotificationsAsRead()
  notify({
    text: 'All notifications marked as read.',
    type: 'success',
  })
}
</script>
